<template>
  <div :style="containerStyle" :class="containerClass">
    <v-card
      flat elevation="3"
      min-width="344" max-width="900"
      class="pa-2 ma-2 rounded-lg"
      style="width:30rem; overflow: hidden"
      v-for="matInfo in materialPoolInfo"
      :key="matInfo.matLbl"
    >
      <v-list-item three-line style="height: 9rem;">
        <v-list-item-content>
          <v-list-item-title class="text-h5 mb-1 text-capitalize">
            {{ matInfo.matLbl }}
          </v-list-item-title>
          <v-list-item-subtitle>
            collected from {{ matInfo.txns.length }} sources
          </v-list-item-subtitle>
          <v-list>
            <v-chip
              v-for="txn in matInfo.txns"
              :key="txn.src.id"
              outlined small label
              class="ma-1"
            >
              {{ txn.src.name }}
            </v-chip>
          </v-list>
        </v-list-item-content>

        <v-list-item-avatar
          tile
          size="80"
          color="white"
        >
          <v-img
            :src="matInfo.iconSrc"
            lazy-src="imgs/logo/gs-logo-circle-128.png"
          />
        </v-list-item-avatar>
      </v-list-item>

      <div class="pa-8 d-flex">
        <p>
          <span class="display-3">
            {{ matInfo.totalQty }}
          </span>
          &nbsp;
          <span class="display-1 font-weight-bold">
            {{ matInfo.totalUts }}
          </span>
        </p>
      </div>

      <v-card-actions>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import * as bkpData from "@/utils/bkpData";
import * as convUtils from "@/utils/convUtils";

let samples = bkpData.fb_items;

// try calling board with multiple item nodes from diff boards
// DASHBOARD_VIEW -- next
// CREATE BID
// AUTOMATION

export default {
  props: {
    "selectedItemNodes": {
      type: Array,
      default: () => []
    },
    "containerStyle": {
      type: String,
      default: ""
    },
    "containerClass": {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      int_selectedItemNodes: [],
      materialPoolInfo: []
    }
  },
  watch: {
    selectedItemNodes: function(newVal, oldVal) {
      this.int_selectedItemNodes = newVal;
      this.extractMatData();
    }
  },
  async mounted() {
    if (Object.keys(this.selectedItemNodes).length === 0) {
      this.int_selectedItemNodes = samples;
    }

    // this.int_selectedItemNodes = samples;
    await this.extractMatData();
  },
  methods: {
    async extractMatData() {
      let itemNodes = this.int_selectedItemNodes;
      let matToPoolInfoDict = convUtils.getRecoverableMatResourcesInfo(itemNodes);
      this.materialPoolInfo = Object.values(matToPoolInfoDict);
    }
  }
}
</script>